import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PanToolAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pan_tool_alt"}/>
}
